export default __webpack_public_path__ + "static/media/logo.6c72d4f4.svg";